module.exports = __webpack_public_path__ + "static/media/icon_envelope.f2fb9d08.svg";